import cn from 'classnames';

import { Column } from './Column';

import { LayoutLoading } from 'components/LayoutLoading';

export function LayoutPageBody({
  children,
  className,
  isError,
  isLoading,
}: Pick<JSX.IntrinsicElements['div'], 'children' | 'className'> & {
  isError?: boolean;
  isLoading?: boolean;
}) {
  return (
    <div className={cn('relative flex flex-1 overflow-hidden', className)}>
      <LayoutLoading isError={isError} isLoading={isLoading} size="small">
        {children}
      </LayoutLoading>
    </div>
  );
}

LayoutPageBody.Column = Column;
